import React from 'react';
import Grid from '@mui/material/Grid';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

const social = () => (
  <>
    <Grid item xs={12} sm={6} className="social-icons">
      <a target="_blank" href="https://www.facebook.com/ResMedAmericas/" rel="noreferrer" id="Footer-LNK-facebook"><FacebookIcon /></a>
      <a target="_blank" href="https://twitter.com/ResMed" rel="noreferrer" id="Footer-LNK-twitter"><TwitterIcon /></a>
      <a target="_blank" href="https://www.linkedin.com/company/resmed/" rel="noreferrer" id="Footer-LNK-linkedin"><LinkedInIcon /></a>
      <a target="_blank" href="https://www.youtube.com/user/ResMedAmericas" rel="noreferrer" id="Footer-LNK-youtube"><YouTubeIcon /></a>
    </Grid>
  </>
);

export default social;
